import type { Dispatch } from '/business/shared/state/actions/types';

const resetReductionEstimate = () => async (dispatch: Dispatch) => {
  dispatch({ type: 'SET_ESTIMATE_REDUCTION_RESET', timestamp: Date.now() });
};
export default resetReductionEstimate;
